import React, { useState, useEffect, useRef } from 'react';

import { Dialog, Card } from '@mui/material';
import { images, icons } from "../../helpers/constants";
import { useTranslation } from "react-i18next";
import Button from '../Buttons/Button';
import { useIsMobile } from '../../helpers/customHooks';
import SegmentedControl from '../SegmentedControl/SegmentedControl';
import NewButton from '../Buttons/NewButton';


const AccountModal = ({ show, data, type, onClose, onSave, deleteAccount }) => {
    const MOBILE = useIsMobile();
    const { t } = useTranslation();
    const inputFile = useRef(null);

    // const [show, setShow] = useState(props.show)
    const [errorText, setErrorText] = useState("")
    const [username, setUsername] = useState("")
    const [age, setAge] = useState("")
    const [weight, setWeight] = useState("")
    const [currentImage, setCurrentImage] = useState()
    const [email, setEmail] = useState("")
    const [confirmEmail, setConfirmEmail] = useState("")
    const [currPass, setCurrPass] = useState("")
    const [newPassword, setNewPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    const [genderValue, setGenderValue] = useState()
    const [imgFile, setImgFile] = useState()

    // useEffect(() => {
    //     setShow(props.show)

    // },[props.show])


    useEffect(() => {
        if(type){
            setUsername(data?.username)
            setAge(data?.birthday && new Date(data.birthday).toISOString().split('T')[0])
            setGenderValue(data?.gender && data.gender)
            setWeight(data?.weight && data.weight)
            setCurrentImage(data?.userimage && data.userimage)
            setConfirmEmail(data?.email)
        }
    }, [type])

    
    const handleClose = () => {
        onClose()
      //  setShow(false)
    }

    const renderGenderSegments = () => {
        const segments = [
            {
                label: t("settings.male"),
                value: "male"
            },
            {
                label: t("settings.female"),
                value: "female"
            },
            {
                label: t("settings.other"),
                value: "other"
            }
        ]
        return (
            <SegmentedControl
                name="psm"
                callback={(val) => handleChangeGender(val)}
                value={genderValue}
                segments={segments}
                segmentWidth="w-100"
                className="bg-light-grey"
            />
        )
    }

    const handleChangeGender = (value) => {
        setGenderValue(value)
    }

    const uploadHandler = () => {
        inputFile.current.click();
    }

    const handleUploadedImg = (imgfile) => {
        if (imgfile) {
            // Create a URL for the file
            const imageUrl = URL.createObjectURL(imgfile);
            // Update your component's state to reflect the new image
            setCurrentImage(imageUrl);
            setImgFile(imgfile)
        }
    }


    const handleChange = (type, e) => {
        switch(type){
            case "username":
                setUsername(e.target.value)
            break;
            case "email":
                setEmail(e.target.value)
            break;
            case "confirmEmail":
                setConfirmEmail(e.target.value)
            break;
            case "currPass":
                setCurrPass(e.target.value)
            break;
            case "newPassword":
                setNewPassword(e.target.value)
            break;
            case "confirmPassword":
                setConfirmPassword(e.target.value)
            break;
            case "age":
                setAge(e.target.value)
            break;
            case "weight":
                setWeight(e.target.value)
            break;
            default: return
        }
        setErrorText("")
    }

    const deleteImg = () => {
        let data = { imageurl: currentImage ?? ""}
        onSave(data)
    }

    const handleSave = (type) => {
        let data = {}
        switch(type){
            case "img": 
                data = imgFile
                break;
            case "username":
                data = { username: username }
                break;
            case "email":
                data = { newemail: confirmEmail, newemailconfirm: confirmEmail }
                break;
            case "password":
                data = { oldpassword: currPass, newpassword: newPassword, newpasswordconfirm: confirmPassword }
                break;
            case "gender":
                data = { gender: genderValue }
                break;
            case "age":
                data = { birthday: age }
                break;
            case "weight":
                data = { weight: parseInt(weight) }
                break;
            default: data = {}
        }
        onSave(data)
    }

    const imgContent = () => {
        return (
            <div className="p-3">
                <div className="d-flex flex-row justify-content-between align-items-center">
                    <div className='d-flex align-items-center'>
                        <h3 className="">{t("settings.change_image")}</h3>
                    </div>
                    <img className="cursor-pointer" src={icons.close_gray} onClick={() => onClose()} alt="..." /> 
                </div>
                <p className="grey-blue py-3">{t("settings.change_image_sub")}</p>
                <div className="d-flex flex-column justify-content-center align-items-center">
                    <img src={currentImage} alt ="" className="w-50" />
                    <p className="thin">{t("settings.preview")}</p>
                    <NewButton onClick={uploadHandler} iconClass={"dark-grey-icon"} icon={icons.plus} className="bg-grey p-3 rounded24 w-25 dark-grey mt-3 body bold ">{t("settings.upload")}</NewButton>
                    <input
                        type="file"
                        id="file"
                        className="cursor-pointer invisible"
                        onChange={(e) => handleUploadedImg(e.target.files[0])}
                        ref={inputFile}
                        style={{ display: "none" }}
                    />
                    </div>
                <div className="d-flex flex-row justify-content-between align-items-center mt-4">
                        {/* <NewButton onClick={() => deleteImg()} className="bg-red p-3 rounded24 w-100 white body bold justify-self-start me-2">{t("settings.delete")}</NewButton> */}
                        <NewButton onClick={() => onClose()} className="bg-grey p-3 rounded24 w-100 dark-grey mx-2 body bold">{t("settings.cancel")}</NewButton>
                        <NewButton onClick={() => handleSave(type)} className="bg-gradient p-3 rounded24 w-100 white-white ms-2 body bold">{t("settings.save")}</NewButton>
                    {/* <div className="d-flex">
  
                    </div> */}

                </div>
            </div>
        )
    }

    const userNameContent = () => {
        return (
            <div className="p-3">
                <div className="d-flex flex-row justify-content-between align-items-center">
                    <div className='d-flex align-items-center'>
                        {/* <img src={icons.user_settings} alt=""/> */}
                        <h3 className="">{t("settings.change_username")}</h3>
                    </div>
                    <img className="cursor-pointer" src={icons.close_gray} onClick={() => onClose()} alt="..." /> 
                </div>
                <p className="grey-blue py-3">{t("settings.change_username_sub")}</p>
                <form>
                    <div className="form-group d-flex align-items-center">
                        <input
                            type="text"
                            className="form-control rounded24 p-3 bg-light-grey grey-blue"
                            id="name"
                            defaultValue={username}
                            onChange={(e) => {
                                handleChange("username", e);
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                e.preventDefault();// Prevent the default Enter key behavior
                                handleSave(type)
                                }
                            }}
                        />
                        <div className="invalid-feedback ms-1 bottom">
                            {errorText === "" ? "" : errorText}
                        </div>
                    </div>
                </form>
                <div className="d-flex flex-row justify-content-between align-items-center mt-4">
                    <NewButton onClick={() => onClose()} className="bg-grey p-3 rounded24 w-100 dark-grey me-2 body bold">{t("settings.cancel")}</NewButton>
                    <NewButton onClick={() => handleSave(type)} className="bg-gradient p-3 rounded24 w-100 white-white ms-2 body bold">{t("settings.save")}</NewButton>
                </div>
            </div>
        )
    }

    const emailContent = () => {
        return (
            <div className="p-3">
                <div className="d-flex flex-row justify-content-between align-items-center">
                        <div className='d-flex align-items-center'>
                        {/* <img src={icons.user_settings} alt=""/> */}
                        <h3 className="">{t("settings.change_email")}</h3>
                    </div>
                    <img className="cursor-pointer" src={icons.close_gray} onClick={() => onClose()} alt="..." /> 
                </div>
                <p className="grey-blue py-3">{t("settings.change_email_sub")}</p>
                {/* <p className="thin">{t("settings.new_email")}</p>
                <form>
                    <div className="form-group d-flex align-items-center">
                        <input
                            type="text"
                            className="form-control bg-light-grey p-2"
                            id="name"	
                            defaultValue={email}
                            onChange={(e) => {
                                handleChange("email", e);
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                e.preventDefault();// Prevent the default Enter key behavior
                                document.getElementById("confirmemail").focus()
                                }
                            }}
                        />
                        <div className="invalid-feedback ms-1 bottom">
                            {errorText === "" ? "" : errorText}
                        </div>
                    </div>
                </form> */}
                {/* <p className="thin">{t("settings.confirm_new_email")}</p> */}
                <form>
                    <div className="form-group d-flex align-items-center">
                        <input
                            type="text"
                            className="form-control rounded24 p-3 bg-light-grey grey-blue body"
                            id="confirmemail"	
                            defaultValue={confirmEmail}
                            onChange={(e) => {
                                handleChange("confirmEmail", e);
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                e.preventDefault();// Prevent the default Enter key behavior
                                handleSave(type)
                                }
                            }}
                        />
                        <div className="invalid-feedback ms-1 bottom">
                            {errorText === "" ? "" : errorText}
                        </div>
                    </div>
                </form>
                <div className="d-flex flex-row justify-content-between align-items-center mt-4">
                    <NewButton onClick={() => onClose()} className="bg-grey p-3 rounded24 w-100 dark-grey me-2 body bold">{t("settings.cancel")}</NewButton>
                    <NewButton onClick={() => handleSave(type)} className="bg-gradient p-3 rounded24 w-100 white-white body bold ms-2">{t("settings.save")}</NewButton>
                </div>
            </div>
        )
    }
    const passwordContent = () => {
        return (
            <div className="p-3">
                <div className="d-flex flex-row justify-content-between align-items-center">
                    <div className='d-flex align-items-center'>
                        {/* <img src={icons.user_settings} alt=""/> */}
                        <h3 className="">{t("settings.change_password")}</h3>
                    </div>
                    <img className="cursor-pointer" src={icons.close_gray} onClick={() => onClose()} alt="..." /> 
                </div>
                <p className="grey-blue py-3">{t("settings.change_password_sub")}</p>
                <form>
                    <div className="form-group d-flex align-items-center mb-3">
                        <input
                            type="password"
                            className="form-control rounded24 p-3 bg-light-grey grey-blue"
                            id="pass"	
                            defaultValue={currPass}
                            placeholder={t("settings.current_password")}
                            onChange={(e) => {
                                handleChange("currPass", e);
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                e.preventDefault();// Prevent the default Enter key behavior
                                document.getElementById("newPass").focus()
                                }
                            }}
                        />
                        <div className="invalid-feedback ms-1 bottom">
                            {errorText === "" ? "" : errorText}
                        </div>
                    </div>
                </form>
                <form>
                    <div className="form-group d-flex align-items-center mb-3">
                        <input
                            type="password"
                            className="form-control rounded24 p-3 bg-light-grey grey-blue"
                            id="newPass"	
                            defaultValue={newPassword}
                            placeholder={t("settings.new_password")}
                            onChange={(e) => {
                                handleChange("newPassword", e);
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                e.preventDefault();// Prevent the default Enter key behavior
                                document.getElementById("confirmPass").focus()
                                }
                            }}
                        />
                        <div className="invalid-feedback ms-1 bottom">
                            {errorText === "" ? "" : errorText}
                        </div>
                    </div>
                </form>
                <form>
                    <div className="form-group d-flex align-items-center mb-3">
                        <input
                            type="password"
                            className="form-control rounded24 p-3 bg-light-grey grey-blue"
                            id="confirmPass"	
                            defaultValue={confirmPassword}
                            placeholder={t("settings.confirm_password")}
                            onChange={(e) => {
                                handleChange("confirmPassword", e);
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                e.preventDefault();// Prevent the default Enter key behavior
                                handleSave(type)
                                }
                            }}
                        />
                        <div className="invalid-feedback ms-1 bottom">
                            {errorText === "" ? "" : errorText}
                        </div>
                    </div>
                </form>
                <div className="d-flex flex-row justify-content-between align-items-center mt-4">
                    <NewButton onClick={() => onClose()} className="bg-grey p-3 rounded24 w-100 dark-grey me-2 body bold">{t("settings.cancel")}</NewButton>
                    <NewButton onClick={() => handleSave(type)} className="bg-gradient p-3 rounded24 w-100 white-white ms-2 body bold">{t("settings.change_password")}</NewButton>
                </div>
            </div>
        )
    }

    const genderContent = () => {
        return (
            <div className="p-3">
                <div className="d-flex flex-row justify-content-between align-items-center">
                    <div className='d-flex align-items-center'>
                        {/* <img src={icons.user_settings} alt=""/> */}
                        <h3 className="">{t("settings.change_gender")}</h3>
                    </div>
                    <img className="cursor-pointer" src={icons.close_gray} onClick={() => onClose()} alt="..." /> 
                </div>
                <p className="grey-blue py-3">{t("settings.change_gender_sub")}</p>
                {renderGenderSegments()}
                <div className="d-flex flex-row justify-content-between align-items-center mt-4">
                    <NewButton onClick={() => onClose()} className="bg-grey p-3 rounded24 w-100 dark-grey me-2 body bold">{t("settings.cancel")}</NewButton>
                    <NewButton onClick={() => handleSave(type)} className="bg-gradient p-3 rounded24 w-100 white-white ms-2 body bold">{t("settings.save")}</NewButton>
                </div>
            </div>
        )
    }


    const ageContent = () => {
        return (
            <div className="p-3">
                <div className="d-flex flex-row justify-content-between align-items-center">
                    <div className='d-flex align-items-center'>
                        {/* <img src={icons.user_settings} alt=""/> */}
                        <h3 className="">{t("settings.change_age")}</h3>
                    </div>
                    <img className="cursor-pointer" src={icons.close_gray} onClick={() => onClose()} alt="..." /> 
                </div>
                <p className="grey-blue py-3">{t("settings.change_age_sub")}</p>
                <form>
                    <div className="form-group d-flex align-items-center">
                        <input
                            type="date"
                            className="form-control bg-light-grey p-2"
                            id="name"
                            defaultValue={age}
                            onChange={(e) => {
                                handleChange("age", e);
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                e.preventDefault();// Prevent the default Enter key behavior
                                handleSave(type)
                                }
                            }}
                        />
                        <div className="invalid-feedback ms-1 bottom">
                            {errorText === "" ? "" : errorText}
                        </div>
                    </div>
                </form>
                <div className="d-flex flex-row justify-content-between align-items-center mt-4">
                    <NewButton onClick={() => onClose()} className="bg-grey p-3 rounded24 w-100 dark-grey me-2 body bold">{t("settings.cancel")}</NewButton>
                    <NewButton onClick={() => handleSave(type)} className="bg-gradient p-3 rounded24 w-100 white-white ms-2 body bold">{t("settings.save")}</NewButton>
                </div>
            </div>
        )
    }

    const weightContent = () => {
        return (
            <div className="p-3">
                <div className="d-flex flex-row justify-content-between align-items-center">
                    <div className='d-flex align-items-center'>
                        {/* <img src={icons.user_settings} alt=""/> */}
                        <h3 className="">{t("settings.change_weight")}</h3>
                    </div>
                    <img className="cursor-pointer" src={icons.close_gray} onClick={() => onClose()} alt="..." /> 
                </div>
                <p className="grey-blue py-3">{t("settings.change_weight_sub")}</p>
                <form>
                    <div className="form-group d-flex align-items-center">
                        <input
                            type="text"
                            className="form-control bg-light-grey p-2"
                            id="name"
                            defaultValue={weight}
                            onChange={(e) => {
                                handleChange("weight", e);
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                e.preventDefault();// Prevent the default Enter key behavior
                                handleSave(type)
                                }
                            }}
                        />
                        <div className="invalid-feedback ms-1 bottom">
                            {errorText === "" ? "" : errorText}
                        </div>
                    </div>
                </form>
                <div className="d-flex flex-row justify-content-between align-items-center mt-4">
                    <NewButton onClick={() => onClose()} className="bg-grey p-3 rounded24 w-100 dark-grey me-2 body bold">{t("settings.cancel")}</NewButton>
                    <NewButton onClick={() => handleSave(type)} className="bg-gradient p-3 rounded24 w-100 white-white ms-2 body bold">{t("settings.save")}</NewButton>
                </div>
            </div>
        )
    }


    const deleteContent = () => {
        return (
            <div className="p-3">
                <div className="d-flex flex-row justify-content-between align-items-center">
                    <div className='d-flex align-items-center'>
                        <h3 className="">{t("settings.delete_account")}</h3>
                    </div>
                    <img className="cursor-pointer" src={icons.close_gray} onClick={() => onClose()} alt="..." /> 
                </div>
                <p className="grey-blue pt-3">{t("settings.delete_account_body")}</p>
                <div className="d-flex flex-row justify-content-between align-items-center mt-4">
                    <NewButton onClick={() => onClose()} className="bg-grey p-3 rounded24 w-100 dark-grey me-2 body bold">{t("settings.cancel")}</NewButton>
                    <NewButton onClick={() => deleteAccount()} className="bg-red p-3 rounded24 w-100 white-white ms-2 body bold">{t("settings.delete")}</NewButton>
                </div>
            </div>
        )
    }

    const typeRender = () => {
        switch(type){
            case "img": return imgContent()
            case "username": return userNameContent()
            case "email": return emailContent()
            case "password": return passwordContent()
            case "gender": return genderContent()
            case "age": return ageContent()
            case "weight": return weightContent()
            case "delete": return deleteContent()
            default: return null
        }
    }
    
    return(
        <>
        <Dialog fullWidth={MOBILE ? true : false} open={show} onClose={handleClose}>
            <Card className="settings-dialog d-flex flex-column scrollable-y">
                <div className="w-100 h-100 grey-blue">
                    {typeRender()}
                </div>
            </Card>
        </Dialog>
        </>
    )
}

export default AccountModal;